import React, { useEffect, useState } from "react";
import FootballStandingTable from "../../common/table/FootballStandingTable";
import LeagueTableW from "../../common/table/LeagueTableW";
import TableGroup from "../../common/table/TableGroup";
import NoDataFound from "../../common/NoDataFound";
import { loadStyles } from "../../../utils/cssLoader";

const FootballTable = ({
  ServerData = {},
  dictionary,
  loadCSS = true,
  dataClient = false,
  title,
  sport = "football",
  websiteBaseUrl,
  dataPath
}) => {
  const [active, setActive] = useState("all");
  const [clientData, setClientData] = useState(null);
  const data = dataClient ? clientData : ServerData;

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  const sortTable = (set) => {
    return [...(set || [])].sort((a, b) =>
      b.pts === a.pts ? b.df - a.df : b.pts - a.pts
    );
  };

  const tabs = [
    { key: "all", label: dictionary?.All || "All", disable: !data?.table?.all },
    {
      key: "home",
      label: dictionary?.Home || "Home",
      disable: !data?.table?.home,
    },
    {
      key: "away",
      label: dictionary?.Away || "Away",
      disable: !data?.table?.away,
    },
    {
      key: "form",
      label: dictionary?.Form || "Form",
      disable: !data?.table?.all,
    },
  ];

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("matchtable");
    }
  }, [loadCSS]);

  if (
    (data?.table?.all?.length === 0 &&
      data?.table?.away?.length === 0 &&
      data?.table?.home?.length === 0 &&
      data?.groups?.length === 0) ||
    (data && typeof data === "object" && Object.keys(data).length === 0)
  ) {
    return (
      <div className="global_table standing_table">
        <NoDataFound type={'table'} />
      </div>
    );
  }

  return (
    <div className="football-table">
      {title && <h1>{title}</h1>}
      <nav className="inner_tab">
        <ul>
          {tabs.map(({ key, label, disable }) => (
            <li
              key={key}
              className={`${active === key ? "active" : ""} ${disable ? "disabled" : ""
                }`}
              onClick={() => !disable && setActive(key)}
              data-name={key}
            >
              <button>{label}</button>
            </li>
          ))}
        </ul>
      </nav>

      {active === "form" && (
        <FootballStandingTable
          data={data?.table?.all}
          disable={false}
          name="form"
        />
      )}

      {tabs
        .filter((tab) => tab.key !== "form")
        .map((tab) => (
          <LeagueTableW
            table={sortTable(data?.table?.[tab.key])}
            teams={data?.teams}
            disable={active !== tab.key}
            name={tab.key}
            dictionary={dictionary}
            key={tab.key}
            sport={sport} websiteBaseUrl={websiteBaseUrl} dataClient={dataClient} dataPath={dataPath}
          />
        ))}

      <TableGroup groups={data?.groups} disable={active} />
    </div>
  );
};

export default FootballTable;
